<template>
    <Head :title="title ? `${title}` : 'Private Gym'">

        <meta v-if="noindex" name="robots" content="noindex">
        <meta v-if="noindex" name=”robots” content=”nofollow”>

        <slot />
    </Head>
</template>

<script>
import { Head } from '@inertiajs/vue3'

export default {
    components: {
        Head,
    },
    props: {
        title: String,
        noindex: {default: false},
    },
}
</script>
